import { IKeHoachThucTapUpdateTrangThaiRequest } from "../../model/request/xet-thuc-tap/IKeHoachThucTapUpdateTrangThaiRequest";
import { IKeHoachThucTap } from "../../model/response/xet-thuc-tap/IKeHoachThucTap";
import { apiClient } from "../apiClient";

const KE_HOACH_THUC_TAP_ENDPOINT = 'ke-hoach-thuc-tap';
export const keHoachTapTapApi = {
    SelectAll: () => apiClient.get(`${KE_HOACH_THUC_TAP_ENDPOINT}`),
    Insert: (data: IKeHoachThucTap) => apiClient.post(`${KE_HOACH_THUC_TAP_ENDPOINT}`, data),
    Update: (id: number, data: IKeHoachThucTap) => apiClient.put(`${KE_HOACH_THUC_TAP_ENDPOINT}/${id}`, data),
    Delete: (id: number) => apiClient.delete(`${KE_HOACH_THUC_TAP_ENDPOINT}/${id}`),  
    UpdateActive: (request: IKeHoachThucTapUpdateTrangThaiRequest) => apiClient.patch(`${KE_HOACH_THUC_TAP_ENDPOINT}/trang-thai`, request),
}